import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { useIsMobile } from 'pricing-pages-lib/js/context/IsMobileContext.tsx';
import BringCommerceCTAs from './BringCommerceCTAs';
import { BringCommerceFeatureHighlights } from './BringCommerceFeatureHighlights';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BringCommerceCtaCard = () => {
  const isMobile = useIsMobile();
  return /*#__PURE__*/_jsx(View, {
    boxShadow: "100",
    minBlockSize: "150px",
    inlineSize: isMobile ? '94%' : '100%',
    paddingBlockStart: isMobile ? '300' : '1000',
    paddingInline: isMobile ? '300' : '1000',
    paddingBlockEnd: isMobile ? '300' : '200',
    position: "relative",
    marginBlock: "0",
    marginInline: "auto",
    children: /*#__PURE__*/_jsxs(Grid, {
      children: [/*#__PURE__*/_jsx(GridItem, {
        size: {
          xs: 12,
          lg: 6
        },
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          marginBlockStart: isMobile ? '800' : undefined,
          paddingInlineEnd: isMobile ? '0' : '1100',
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h4",
            "aria-level": 2,
            color: "text-core-default",
            paddingBlockEnd: "300",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricingPage.pages.commerce.card.title"
            })
          }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "pricingPage.pages.commerce.card.description_jsx",
            elements: {
              br: () => /*#__PURE__*/_jsx("br", {})
            }
          }), /*#__PURE__*/_jsx(View, {
            marginBlockStart: "900",
            maxInlineSize: isMobile ? '100%' : '350px',
            inlineSize: "100%",
            children: /*#__PURE__*/_jsx(BringCommerceCTAs, {})
          })]
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        size: {
          xs: 12,
          lg: 6
        },
        children: /*#__PURE__*/_jsx(Flex, {
          flexDirection: "column",
          marginBlockStart: isMobile ? '800' : '0',
          children: /*#__PURE__*/_jsx(BringCommerceFeatureHighlights, {})
        })
      })]
    })
  });
};
export default BringCommerceCtaCard;